import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard, FeatureGuard } from '@ta/user';

export enum EVisitsRoute {
  visits = 'visits',
  list = 'list',
  availability = 'availability',
  details = 'details',
}

TaRoutes.addRoute({
  key: EVisitsRoute.visits,
  url: 'visits',
  children: [
    {
      key: EVisitsRoute.list,
      url: 'list',
    },
    {
      key: EVisitsRoute.availability,
      url: 'availability',
    },
    {
      key: EVisitsRoute.details,
      url: 'detail/:id',
    },
  ],
});

export const visitsRoutes: Routes = [
  {
    path: TaRoutes.getUrl([EVisitsRoute.visits, EVisitsRoute.list]),
    title: 'app.pages.visits.title',
    loadComponent: () => import('./pages/my-visits/my-visits').then((c) => c.MyVisitsPage),
  },
  {
    path: TaRoutes.getUrl([EVisitsRoute.visits, EVisitsRoute.availability]),
    title: 'app.pages.visit_availability.title',
    loadComponent: () =>
      import('./pages/my-availability/my-availability').then((c) => c.MyAvailabilityPage),
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: 'visitAvailability', level: 'authorize' },
  },
  {
    path: TaRoutes.getUrl([EVisitsRoute.visits, EVisitsRoute.details]),
    title: 'app.pages.visit_details.title',
    loadComponent: () => import('./pages/visit-detail/visit-detail').then((c) => c.VisitDetailPage),
  },
];
